/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Box,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  Select,
  Slider,
  SliderProps,
  TextField,
  TextFieldProps,
} from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import ClearIcon from '@material-ui/icons/Clear'
import { CustomTooltip } from 'components/facets'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AnyYesNo } from 'shared'

interface FilterProps {
  type?: 'slider' | 'switchText' | 'select'
  label: string
  name: string
  inputProps?: TextFieldProps
  sliderProps?: SliderProps
  defaultValue?: any
  grid?: boolean
  menuitems?: JSX.Element[]
  setFilter: (name: string, newValue: any) => void
  activeFilter?: boolean
}

export const Filter = ({
  label,
  name,
  type,
  inputProps,
  menuitems,
  sliderProps,
  defaultValue,
  grid,
  setFilter,
  activeFilter,
}: FilterProps): JSX.Element => {
  const getInitialState = (): any => {
    if (defaultValue !== null && defaultValue !== undefined) {
    }
    return defaultValue
  }

  const [value, setValue] = useState(getInitialState())
  const [loaded, setLoaded] = useState(false)
  const [includes, setIncludes] = useState(true)
  const { t } = useTranslation()

  const handleChange = (newValue: any): void => {
    setValue(newValue)
  }

  useEffect(() => {
    const filterValue = includes ? value : `!${value}`
    const handler = setTimeout(() => {
      if (loaded) {
        setFilter(name, filterValue)
      } else {
        setLoaded(true)
      }
    }, 400)
    return () => {
      clearTimeout(handler)
    }
  }, [value, includes])

  const InputComponent = (): JSX.Element => {
    if (type === 'slider')
      return (
        <>
          <InputLabel className={activeFilter ? `active-filter` : ''}>{label}</InputLabel>

          <Slider
            value={value}
            data-testid={`${name}-slider`}
            onChange={(_e, newValue) => handleChange(newValue)}
            valueLabelDisplay={'auto'}
            {...sliderProps}
          />
        </>
      )
    else if (type === 'select')
      return (
        <FormControl fullWidth>
          <InputLabel className={`${value}` !== AnyYesNo.Any ? `active-filter` : ``}>
            {label}
          </InputLabel>
          <Select
            name={name}
            value={value}
            onChange={(e) => handleChange(e.target.value)}
            className={`${value}` !== AnyYesNo.Any ? `active-filter` : ``}
            data-testid={`${name}-select`}
          >
            {menuitems?.map((menuItem) => menuItem)}
          </Select>
        </FormControl>
      )
    else if (type === 'switchText')
      return (
        <Grid container>
          <Grid item xs={10}>
            <TextField
              fullWidth
              multiline={true}
              label={label}
              name={name}
              value={value}
              onChange={(e) => handleChange(e.target.value)}
              {...inputProps}
              InputProps={{
                style: { fontWeight: 'bold', minHeight: value ? 'initial' : '32px' },
              }}
            />
          </Grid>
          <Grid xs={2} item style={{ display: 'flex', alignItems: 'flex-end' }}>
            <CustomTooltip title={String(includes ? t('includes') : t('doesNotInclude'))}>
              <IconButton
                data-testid={`${name}-includes`}
                onClick={() => setIncludes(!includes)}
                size="small"
              >
                {includes ? <CheckIcon /> : <ClearIcon />}
              </IconButton>
            </CustomTooltip>
          </Grid>
        </Grid>
      )
    return (
      <TextField
        fullWidth
        label={label}
        data-testid={name + 'input-text'}
        //multiline={true}
        name={name}
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        {...inputProps}
        InputProps={{
          style: { fontWeight: 'bold' },
        }}
      />
    )
  }
  if (!grid) return <Box>{InputComponent()}</Box>
  else {
    return (
      <Grid item md={6} xs={12}>
        <Box>{InputComponent()}</Box>
      </Grid>
    )
  }
}
